// Welcome screen
export const LANDING_LOGIN_BUTTON = 'LANDING_LOGIN_BUTTON';

// Login screen
export const LOGIN_USERNAME = 'LOGIN_USERNAME';
export const LOGIN_PASSWORD = 'LOGIN_PASSWORD';
export const LOGIN_BUTTON = 'LOGIN_BUTTON';
export const LOGIN_USERNAME_EMPTY_MESSAGE = 'LOGIN_USERNAME_EMPTY_MESSAGE';
export const LOGIN_PASSWORD_EMPTY_MESSAGE = 'LOGIN_PASSWORD_EMPTY_MESSAGE';
export const LOGIN_FAILED_TITLE = 'LOGIN_FAILED_TITLE';
export const LOGIN_FAILED_DESCRIPTION = 'LOGIN_FAILED_DESCRIPTION';
export const TRY_AGAIN_BUTTON_ID = 'TRY_AGAIN_BUTTON';

// QR Login screen
export const QR_LOGIN_CAMERA_NOT_ALLOWED_TITLE =
    'QR_LOGIN_CAMERA_NOT_ALLOWED_TITLE';
export const QR_LOGIN_CAMERA_NOT_ALLOWED_DESCRIPTION =
    'QR_LOGIN_CAMERA_NOT_ALLOWED_DESCRIPTION';
export const QR_LOGIN_BUTTON_GO_TO_SETTINGS = 'QR_LOGIN_BUTTON_GO_TO_SETTINGS';
export const QR_LOGIN_BACK_BUTTON = 'QR_LOGIN_BACK_BUTTON';

// Forgot password
export const FORGOT_PASSWORD_BUTTON = 'FORGOT_PASSWORD_BUTTON';
export const FORGOT_PASSWORD_TITLE_ID = 'FORGOT_PASSWORD_TITLE';
export const FORGOT_PASSWORD_DESCRIPTION_ID = 'FORGOT_PASSWORD_DESCRIPTION';
export const CLOSE_BUTTON_ID = 'CLOSE_BUTTON';
export const SELFCARE_BUTTON_ID = 'SELFCARE_BUTTON_ID';

// Loading Screen
export const LOADING_SPINNER_ID = 'LOADING_SPINNER_ID';
export const LOADING_TEXT_ID = 'LOADING_TEXT_ID';

// Spotlight Screen
export const SPOTLIGHT_TITLE_ID = 'SPOTLIGHT_TITLE_ID';
export const SPOTLIGHT_DESCRIPTION_ID = 'SPOTLIGHT_DESCRIPTION_ID';
export const SPOTLIGHT_SKIP_BUTTON_ID = 'SPOTLIGHT_SKIP_BUTTON_ID';
export const SPOTLIGHT_WATCH_BUTTON_ID = 'SPOTLIGHT_WATCH_BUTTON_ID';

// Main menu
export const TOP_BAR_NAVIGATION_ID = 'TOP_BAR_NAVIGATION_ID';
export const HOME_MENU_ITEM_ID = 'HOME_MENU_ITEM_ID';
export const TV_MENU_ITEM_ID = 'TV_MENU_ITEM_ID';
export const RECORDINGS_MENU_ITEM_ID = 'RECORDINGS_MENU_ITEM_ID';
export const ONDEMAND_MENU_ITEM_ID = 'ONDEMAND_MENU_ITEM_ID';
export const SEARCH_MENU_ITEM_ID = 'SEARCH_MENU_ITEM_ID';
export const SETTINGS_MENU_ITEM_ID = 'SETTINGS_MENU_ITEM_ID';
export const PROFILE_MENU_ITEM_ID = 'PROFILE_MENU_ITEM_ID';
export const FALLBACK_MESSAGE_ID = 'FALLBACK_MESSAGE_ID';

// Stripes
export const STRIPE_TITLE_ID = 'STRIPE_TITLE_ID';
export const STRIPE_TYPE = 'STRIPE_TYPE';
export const ASSET_CARD = 'ASSET_CARD';

// Gallery
export const MORE_INFO_BUTTON_ID = 'MORE_INFO_BUTTON_ID';
export const CHANNEL_LOGO_ID = 'CHANNEL_LOGO_ID';
export const ASSET_TITLE_ID = 'ASSET_TITLE_ID';
export const ASSET_SEASON_EPISODE_NUMBER_ID = 'ASSET_SEASON_EPISODE_NUMBER_ID';
export const ASSET_METADATA_ID = 'ASSET_METADATA_ID';
export const ASSET_CONTENT_MARKER_ID = 'ASSET_CONTENT_MARKER_ID';
export const ASSET_PARENTAL_RATING = 'ASSET_PARENTAL_RATING';
export const GALLERY_LEFT_ARROW_BUTTON_ID = 'GALLERY_LEFT_ARROW_BUTTON_ID';
export const GALLERY_RIGHT_ARROW_BUTTON_ID = 'GALLERY_RIGHT_ARROW_BUTTON_ID';

// Settings
export const PAGE_TITLE_ID = 'PAGE_TITLE_ID';
export const PARENTAL_CONTROL_PIN_ID = 'PARENTAL_CONTROL_PIN_ID';
export const RECORDING_QUOTA_ID = 'RECORDING_QUOTA_ID';
export const INTERNET_CONNECTION_ID = 'SETTINGS_RN_INTERNET_CONNECTION_OPTION';
export const CHANNEL_LINEUP_SELECTION_ID = 'CHANNEL_LINEUP_SELECTION_ID';
export const MY_STREAMING_SUBSCRIPTIONS_ID = 'MY_STREAMING_SUBSCRIPTIONS_ID';
export const EPG_DISPLAY_ID = 'EPG_DISPLAY_ID';
export const AUDIO_SUBTITLES_ID = 'AUDIO_SUBTITLES_ID';
export const DELETE_HISTORY_ID = 'DELETE_HISTORY_ID';
export const CONSENTS_ID = 'CONSENTS_ID';
export const PROFILE_MOBILE_ID = 'PROFILE_MOBILE_ID';
export const SPOTLIGHT_VIDEO_ID = 'SPOTLIGHT_VIDEO_ID';
export const ABOUT_APP_ID = 'ABOUT_APP_ID';
export const HELP_ID = 'HELP_ID';
export const LOG_OUT_ID = 'LOG_OUT_ID';
export const TERMS_CONDITIONS_TITLE_ID = 'TERMS_CONDITIONS_TITLE_ID';
export const TERMS_CONDITIONS_DESCRIPTION_ID =
    'TERMS_CONDITIONS_DESCRIPTION_ID';
export const TERMS_CONDITIONS_LINK_ID = 'TERMS_CONDITIONS_LINK_ID';
export const TERMS_CONDITIONS_CLOSE_BUTTON_ID =
    'TERMS_CONDITIONS_CLOSE_BUTTON_ID';

// TV
export const EPG_DATE_PICKER_BUTTON_ID = 'EPG_DATE_PICKER_BUTTON_ID';
export const DATE_PICKER_YESTERDAY_ID = 'DATE_PICKER_YESTERDAY_ID';
export const DATE_PICKER_TODAY_ID = 'DATE_PICKER_TODAY_ID';
export const DATE_PICKER_TOMORROW_ID = 'DATE_PICKER_TOMORROW_ID';
export const DATE_PICKER_DYNAMIC_ID = 'DATE_PICKER_DYNAMIC_ID';
export const CHANNEL_LIST_ITEM_ID = 'CHANNEL_LIST_ITEM_ID';
export const PROGRAM_LIST_ITEM_ID = 'PROGRAM_LIST_ITEM_ID';
export const PROGRAM_GRID_NOW = 'PROGRAM_GRID_NOW';
export const PROGRAM_GRID_PAST = 'PROGRAM_GRID_PAST';
export const PROGRAM_GRID_FUTURE = 'PROGRAM_GRID_FUTURE';
export const PROGRAM_ICON_TYPE_ID = 'PROGRAM_ICON_TYPE_ID';
export const TIMELINE_NOW_ID = 'TIMELINE_NOW_ID';
export const LEFT_NAVIGATION_ARROW_ID = 'LEFT_NAVIGATION_ARROW_ID';
export const RIGHT_NAVIGATION_ARROW_ID = 'RIGHT_NAVIGATION_ARROW_ID';
export const EPG_PROGRAM_CELLS_LOADING_ID = 'EPG_PROGRAM_CELLS_LOADING_ID';
export const EPG_PROGRAM_NO_INFORMATION_ID = 'EPG_PROGRAM_NO_INFORMATION_ID';

// TV Filter
export const EPG_FILTER_BUTTON_ID = 'EPG_FILTER_BUTTON_ID';
export const EPG_FILTER_ITEM_ID = 'EPG_FILTER_ITEM_ID';

// Search
export const SEARCH_ICON_ID = 'SEARCH_ICON_ID';
export const SEARCH_INPUT_ID = 'SEARCH_INPUT_ID';
export const SEARCH_X_ICON_ID = 'SEARCH_X_ICON_ID';
export const SEARCH_CANCEL_BUTTON_ID = 'SEARCH_CANCEL_BUTTON_ID';

// Detail
export const DETAIL_CHANNEL_LOGO_ID = 'DETAIL_CHANNEL_LOGO_ID';
export const DETAIL_PROGRAM_TITLE_ID = 'DETAIL_PROGRAM_TITLE_ID';
export const DETAIL_WATCH_BUTTON = 'DETAIL_WATCH_BUTTON';
export const DETAIL_RECORD_BUTTON = 'DETAIL_RECORD_BUTTON';
export const DETAIL_METADATA_ID = 'DETAIL_METADATA_ID';
export const DETAIL_DESCRIPTION_ID = 'DETAIL_DESCRIPTION_ID';
export const DETAIL_DESCRIPTION_MORE_BUTTON_ID =
    'DETAIL_DESCRIPTION_MORE_BUTTON_ID';
export const DETAIL_MORE_INFO_OVERLAY_ID = 'DETAIL_MORE_INFO_OVERLAY_ID';
export const DETAIL_MORE_INFO_OVERLAY_TITLE = 'DETAIL_MORE_INFO_OVERLAY_TITLE';
export const DETAIL_MORE_INFO_OVERLAY_DESCRIPTION =
    'DETAIL_MORE_INFO_OVERLAY_DESCRIPTION';
export const DETAIL_MORE_INFO_OVERLAY_CLOSE_ICON =
    'DETAIL_MORE_INFO_OVERLAY_CLOSE_ICON';
export const DETAIL_SEASON_TAB_ID = 'DETAIL_SEASON_TAB_ID';
export const DETAIL_SEASON_TAB_OTHER_ID = 'DETAIL_SEASON_TAB_OTHER_ID';
export const DETAIL_EPISODE_STRIPE_ID = 'DETAIL_EPISODE_STRIPE_ID';
export const DETAIL_SKELETON_ID = 'DETAIL_SKELETON_ID';
export const DETAIL_ERROR_TITLE = 'DETAIL_ERROR_TITLE';
export const DETAIL_ERROR_DESCRIPTION = 'DETAIL_ERROR_DESCRIPTION';
export const DETAIL_ERROR_CANCEL = 'DETAIL_ERROR_CANCEL';
export const DETAIL_ERROR_CODE = 'DETAIL_ERROR_CODE';
export const DETAIL_CAST_TITLE = 'DETAIL_CAST_TITLE';
export const DETAIL_CAST_CREW = 'DETAIL_CAST_CREW';
export const DETAIL_CAST_CREW_ARROW = 'DETAIL_CAST_CREW_ARROW';
export const DETAIL_PROTECT_RECORDING = 'DETAIL_PROTECT_RECORDING';
export const DETAIL_UNPROTECT_RECORDING = 'DETAIL_UNPROTECT_RECORDING';
export const DETAIL_DELETE_RECORDING = 'DETAIL_DELETE_RECORDING';
export const DETAIL_RECORD_SERIES = 'DETAIL_RECORD_SERIES';
export const DETAIL_DELETE_SERIES = 'DETAIL_DELETE_SERIES';
export const BUTTON_RENT_SUBSCRIBE = 'BUTTON_RENT_SUBSCRIBE';
export const BUTTON_RENT = 'BUTTON_RENT';
export const BUTTON_SUBSCRIBE = 'BUTTON_SUBSCRIBE';
export const RENT_OVERLAY_TITLE = 'RENT_OVERLAY_TITLE';
export const RENT_OVERLAY_DESCRIPTION = 'RENT_OVERLAY_DESCRIPTION';
export const RENT_OVERLAY_RENT_PERIOD = 'RENT_OVERLAY_RENT_PERIOD';
export const RENT_OVERLAY_RENT_PRICE = 'RENT_OVERLAY_RENT_PRICE';
export const CLOSE_BUTTON = 'CLOSE_BUTTON';
export const DETAIL_AUDIO_LANGUAGE_TEXT = 'DETAIL_AUDIO_LANGUAGE_TEXT_ID';
export const DETAIL_SUBTITLES_TEXT = 'DETAIL_SUBTITLES_TEXT_ID';
export const DETAIL_SEASON_SELECTOR = 'DETAIL_SEASON_SELECTOR_ID';
export const DETAIL_PROGRAMS_TAB = 'DETAIL_PROGRAMS_TAB_ID';
export const DETAIL_RECORDINGS_TAB = 'DETAIL_RECORDINGS_TAB_ID';
export const DETAIL_SEASON_TAB = 'DETAIL_SEASON_TAB_ID';

// Content Marker Icons
export const DETAIL_AGE_RATING_ICON = 'DETAIL_AGE_RATING_ICON_ID';
export const DETAIL_SUBSCRIBE_ICON = 'DETAIL_SUBSCRIBE_ICON_ID';
export const DETAIL_REPLAY_ICON = 'DETAIL_REPLAY_ICON_ID';
export const DETAIL_CATCHUP_ICON = 'DETAIL_CATCHUP_ICON_ID';
export const DETAIL_RECORDING_ICON = 'DETAIL_RECORDING_ICON_ID';
export const DETAIL_LOCK_ICON = 'DETAIL_LOCK_ICON_ID';

// PIN
export const YOUR_CURRENT_PIN_ID = 'YOUR_CURRENT_PIN_ID';
export const PIN_CLOSE_BUTTON_ID = 'PIN_CLOSE_BUTTON_ID';

// No Network Connection
export const NO_NETWORK_CONNECTION_TITLE_ID = 'NO_NETWORK_CONNECTION_TITLE_ID';
export const NO_NETWORK_CONNECTION_DESCRIPTION_ID =
    'NO_NETWORK_CONNECTION_DESCRIPTION_ID';
export const NO_NETWORK_CONNECTION_TRY_AGAIN_BUTTON_ID =
    'NO_NETWORK_CONNECTION_TRY_AGAIN_BUTTON_ID';

// Bottom Sheet
export const BOTTOM_SHEET_CLOSE_BUTTON_ID = 'BOTTOM_SHEET_CLOSE_BUTTON_ID';

export const LOGO_TEST_ID = 'LOGO_TEST_ID';

// Profile flow
export const PROFILE_SELECTION_TITLE = 'PROFILE_SELECTION_TITLE';
export const PROFILE_SELECTION_DESCRIPTION = 'PROFILE_SELECTION_DESCRIPTION';
export const PROFILE_NAME = 'PROFILE_NAME';
export const ADD_PROFILE_SELECTION_TITLE = 'ADD_PROFILE_SELECTION_TITLE';
export const PROFILE_CLOSE_BUTTON = 'PROFILE_CLOSE_BUTTON';
export const PROFILE_MANAGE_BUTTON = 'PROFILE_MANAGE_BUTTON';
export const PROFILE_ADD_PROFILE_ERROR_TITLE =
    'PROFILE_ADD_PROFILE_ERROR_TITLE';
export const PROFILE_EDIT_PROFILE_ERROR_TITLE =
    'PROFILE_EDIT_PROFILE_ERROR_TITLE';
export const PROFILE_DELETE_PROFILE_ERROR_TITLE =
    'PROFILE_DELETE_PROFILE_ERROR_TITLE';
export const PROFILE_KIDS_NOT_ALLOWED_TITLE = 'PROFILE_KIDS_NOT_ALLOWED_TITLE';
export const PROFILE_ADD_PROFILE_ERROR_DESCRIPTION =
    'PROFILE_ADD_PROFILE_ERROR_DESCRIPTION';
export const PROFILE_EDIT_PROFILE_ERROR_DESCRIPTION =
    'PROFILE_EDIT_PROFILE_ERROR_DESCRIPTION';
export const PROFILE_DELETE_PROFILE_ERROR_DESCRIPTION =
    'PROFILE_DELETE_PROFILE_ERROR_DESCRIPTION';
export const PROFILE_KIDS_NOT_ALLOWED_DESCRIPTION =
    'PROFILE_KIDS_NOT_ALLOWED_DESCRIPTION';
export const PROFILE_ADD_PROFILE_ERROR_CODE = 'PROFILE_ADD_PROFILE_ERROR_CODE';
export const PROFILE_EDIT_PROFILE_ERROR_CODE =
    'PROFILE_EDIT_PROFILE_ERROR_CODE';
export const PROFILE_DELETE_PROFILE_ERROR_CODE =
    'PROFILE_DELETE_PROFILE_ERROR_CODE';
export const PROFILE_OK_BUTTON = 'PROFILE_OK_BUTTON';
export const PROFILE_TRY_AGAIN_BUTTON = 'PROFILE_TRY_AGAIN_BUTTON';
export const PROFILE_BACK_BUTTON = 'PROFILE_BACK_BUTTON';
export const PROFILE_CLOSE_BUTTON_EDIT_MODE = 'PROFILE_CLOSE_BUTTON_EDIT_MODE';
export const ADD_PROFILE_NAME = 'ADD_PROFILE_NAME';
export const SELECT_PROFILE_TYPE_TITLE = 'SELECT_PROFILE_TYPE_TITLE';
export const SELECT_PROFILE_TYPE_DESCRIPTION =
    'SELECT_PROFILE_TYPE_DESCRIPTION';
export const PROFILE_TYPE_STANDARD = 'PROFILE_TYPE_STANDARD';
export const PROFILE_TYPE_KIDS = 'PROFILE_TYPE_KIDS';
export const PROFILE_AGE_RATING_ITEM = 'PROFILE_AGE_RATING_ITEM';
export const EDIT_PROFILE_TITLE = 'EDIT_PROFILE_TITLE';
export const EDIT_PROFILE_DESCRIPTION = 'EDIT_PROFILE_DESCRIPTION';
export const EDIT_PROFILE_SAVE_BUTTON = 'EDIT_PROFILE_SAVE_BUTTON';
export const EDIT_PROFILE_DELETE_BUTTON = 'EDIT_PROFILE_DELETE_BUTTON';
export const DELETE_PROFILE_TITLE = 'DELETE_PROFILE_TITLE';
export const DELETE_PROFILE_DESCRIPTION = 'DELETE_PROFILE_DESCRIPTION';
export const PROFILE_KEEP_BUTTON = 'PROFILE_KEEP_BUTTON';
export const PROFILE_DELETE_BUTTON = 'PROFILE_DELETE_BUTTON';
export const PROFILE_AGE_RATING_BUTTON = 'PROFILE_AGE_RATING_BUTTON';
export const PROFILE_AVATAR = 'PROFILE_AVATAR';
export const PROFILE_DELETE_NOT_ALLOWED_TITLE =
    'PROFILE_DELETE_NOT_ALLOWED_TITLE';
export const PROFILE_DELETE_NOT_ALLOWED_BODY =
    'PROFILE_DELETE_NOT_ALLOWED_BODY';
export const PROFILE_ICON = 'PROFILE_ICON';
export const ADD_PROFILE_SAVE_BUTTON = 'ADD_PROFILE_SAVE_BUTTON';

// Content Rating Overlay
export const TITLE_PARENTAL_RATING_CONTENT = 'TITLE_PARENTAL_RATING_CONTENT';
export const DESCRIPTION_PARENTAL_RATING_CONTENT =
    'DESCRIPTION_PARENTAL_RATING_CONTENT';
export const ICON_PARENTAL_RATING_CONTENT = 'ICON_PARENTAL_RATING_CONTENT';
export const CLOSE_BUTTON_PARENTAL_RATING_CONTENT =
    'ICON_PARENTAL_RATING_CONTENT';

// Header
export const BACK_BUTTON_ID = 'BACK_BUTTON_ID';
export const HEADER_TITLE_ID = 'HEADER_TITLE_ID';

// Markers
export const UNSUBSCRIBED_MARKER_ID = 'UNSUBSCRIBED_MARKER_ID';

// Player
export const PLAYER_PLAY_BUTTON_ID = 'PLAYER_PLAY_BUTTON_ID';
export const PLAYER_PAUSE_BUTTON_ID = 'PLAYER_PAUSE_BUTTON_ID';
export const PLAYER_REPLAY_BUTTON = 'PLAYER_REPLAY_BUTTON_ID';
export const PLAYER_CAST_BUTTON = 'PLAYER_CAST_BUTTON_ID';
export const PLAYER_SKIP_FORWARD = 'PLAYER_SKIP_FORWARD_ID';
export const PLAYER_SKIP_BACKWARD = 'PLAYER_SKIP_BACKWARD_ID';
export const PLAYER_CLOSE_BUTTON = 'PLAYER_CLOSE_BUTTON_ID';
export const PLAYER_FULL_SCREEN_ICON = 'PLAYER_FULL_SCREEN_ICON_ID';
export const PLAYER_VOLUME_ON_ICON = 'PLAYER_VOLUME_ON_ICON';
export const PLAYER_VOLUME_OFF_ICON = 'PLAYER_VOLUME_OFF_ICON';
export const PLAYER_EXIT_FULL_SCREEN_ICON = 'PLAYER_EXIT_FULL_SCREEN_ICON_ID';
export const PLAYER_AUDIO_SUBTITLES_BUTTON = 'PLAYER_AUDIO_SUBTITLES_BUTTON_ID';
export const PLAYER_JUMP_TO_LIVE_BUTTON = 'PLAYER_JUMP_TO_LIVE_BUTTON_ID';
export const PLAYER_PROGRAM_TITLE = 'PLAYER_PROGRAM_TITLE_ID';
export const PLAYER_PROGRAM_METADATA = 'PLAYER_PROGRAM_METADATA_ID';
export const PLAYER_MARKER_ID = 'PLAYER_MARKER_ID';
export const PLAYER_RECORDING_ACTION_ID = 'PLAYER_RECORDING_ACTION_ID';
export const PLAYER_FIT_TO_SCREEN_BUTTON_ID = 'PLAYER_FIT_TO_SCREEN_BUTTON_ID';
export const PLAYER_AIR_PLAY_BUTTON_ID = 'PLAYER_AIR_PLAY_BUTTON_ID';
export const PLAYER_BRIGHTNESS_CONTROL = 'PLAYER_BRIGHTNESS_CONTROL_ID';
export const PLAYER_PROGRESS_COUNTER_RIGHT = 'PLAYER_PROGRESS_COUNTER_RIGHT_ID';
export const PLAYER_PROGRESS_COUNTER_LEFT = 'PLAYER_PROGRESS_COUNTER_LEFT_ID';
export const PLAYER_PROGRESS_BAR = 'PLAYER_PROGRESS_BAR_ID';
export const PLAYER_CHANNEL_NAME = 'PLAYER_CHANNEL_NAME_ID';

// Audio & Subtitles overlay
export const SUBTITLE_AUDIO_OVERLAY_CLOSE_BUTTON =
    'PLAYER_SUBTITLE_AUDIO_OVERLAY_CLOSE_BUTTON_ID';
export const AUDIO_LANGUAGE_SECTION_TITLE = 'AUDIO_LANGUAGE_SECTION_TITLE_ID';
export const SUBTITLES_SECTION_TITLE = 'SUBTITLES_SECTION_TITLE_ID';
export const AUDIO_LANGUAGE_OPTION = 'AUDIO_LANGUAGE';
export const SUBTITLE_OPTION = 'SUBTITLE';

// My List
export const RESET_MY_LIST_TITLE = 'RESET_MY_LIST_TITLE';
export const RESET_MY_LIST_DESCRIPTION = 'RESET_MY_LIST_DESCRIPTION';
export const RESET_MY_LIST_CANCEL_BUTTON = 'RESET_MY_LIST_CANCEL_BUTTON';
export const RESET_MY_LIST_RESET_BUTTON = 'RESET_MY_LIST_RESET_BUTTON';
export const CREATE_MY_LIST_TITLE = 'CREATE_MY_LIST_TITLE';
export const CREATE_MY_LIST_DESCRIPTION = 'CREATE_MY_LIST_DESCRIPTION';
export const CREATE_MY_LIST_START_BUTTON = 'CREATE_MY_LIST_START_BUTTON';
export const SAVE_MY_LIST_TITLE = 'SAVE_MY_LIST_TITLE';
export const SAVE_MY_LIST_DESCRIPTION = 'SAVE_MY_LIST_DESCRIPTION';
export const SAVE_MY_LIST_BUTTON = 'SAVE_MY_LIST_BUTTON';
export const SAVE_MY_LIST_CANCEL_BUTTON = 'SAVE_MY_LIST_CANCEL_BUTTON';
export const MY_LIST_CHANNELS_HIDDEN_TITLE = 'MY_LIST_CHANNELS_HIDDEN_TITLE';
export const MY_LIST_CHANNELS_HIDDEN_DESCRIPTION =
    'MY_LIST_CHANNELS_HIDDEN_DESCRIPTION';
export const MY_LIST_CHANNELS_HIDDEN_BUTTON = 'MY_LIST_CHANNELS_HIDDEN_BUTTON';

// NPVR Recording Dialogs
export const CANCEL_EPISODE_DIALOG_TITLE = 'CANCEL_EPISODE_DIALOG_TITLE';
export const CANCEL_EPISODE_DESCRIPTION = 'CANCEL_EPISODE_DESCRIPTION';
export const CANCEL_EPISODE_YES_BUTTON = 'CANCEL_EPISODE_YES_BUTTON';
export const CANCEL_EPISODE_NO_BUTTON = 'CANCEL_EPISODE_NO_BUTTON';
export const CANCEL_SERIES_DIALOG_TITLE = 'CANCEL_SERIES_DIALOG_TITLE';
export const CANCEL_SERIES_DESCRIPTION = 'CANCEL_SERIES_DESCRIPTION';
export const CANCEL_SERIES_YES_BUTTON = 'CANCEL_SERIES_YES_BUTTON';
export const CANCEL_SERIES_NO_BUTTON = 'CANCEL_SERIES_NO_BUTTON';
export const DELETE_EPISODE_DIALOG_TITLE = 'DELETE_EPISODE_DIALOG_TITLE';
export const DELETE_EPISODE_DESCRIPTION = 'DELETE_EPISODE_DESCRIPTION';
export const DELETE_EPISODE_YES_BUTTON = 'DELETE_EPISODE_YES_BUTTON';
export const DELETE_EPISODE_NO_BUTTON = 'DELETE_EPISODE_NO_BUTTON';
export const DELETE_SERIES_DIALOG_TITLE = 'DELETE_SERIES_DIALOG_TITLE';
export const DELETE_SERIES_DESCRIPTION = 'DELETE_SERIES_DESCRIPTION';
export const DELETE_SERIES_YES_BUTTON = 'DELETE_SERIES_YES_BUTTON';
export const DELETE_SERIES_NO_BUTTON = 'DELETE_SERIES_NO_BUTTON';
